import { createApi } from "@reduxjs/toolkit/query/react";

import { IManager } from "@/interfaces/manager.interface";
import { BaseWithAuth, getWorkspace } from "@/utils/helpers";

export const managerApi = createApi({
  reducerPath: "managerApi",
  baseQuery: BaseWithAuth(),
  tagTypes: ["manager"],
  endpoints: (builder) => ({
    // get list of manager
    getManagerList: builder.query<
      GeneralResponse<IManager[]>,
      Partial<{ status: string; filter?: string }>
    >({
      query: ({ status, filter }) =>
        `/superadmin/workforce/manager${status ? `?status=${status}` : ""}${filter ? filter : ""}`,
      providesTags: ["manager"],
    }),

    // list of manager according to the  workspace
    getManagerByWS: builder.query<
      GeneralResponse<IManager[]>,
      Partial<{ status: string; filter?: string }>
    >({
      query: ({ status, filter }) =>
        `workspace/${getWorkspace()}/workforce/manager${status ? `?status=${status}` : ""}${filter ? filter : ""}`,
      providesTags: ["manager"],
    }),

    // get single subconstractor
    getSingleManagerByWs: builder.query<IManager, { userId: string }>({
      query: ({ userId }) =>
        `workspace/${getWorkspace()}/workforce/manager/${userId}`,
      providesTags: ["manager"],
      transformResponse: (response: APIResponse<IManager>) => response?.data,
    }),

    //Update or delete manager
    alterManagerByWs: builder.mutation<
      object,
      Partial<{
        data: object;
        userId: string;
        method?: string;
      }>
    >({
      query: ({ data, userId, method }) => ({
        url: `workspace/${getWorkspace()}/workforce/manager/${userId ? userId : "ss"}`,
        method: method?.toUpperCase() || "PUT",
        body: data,
      }),
      invalidatesTags: ["manager"],
    }),

    //Add manager
    addManagerByWs: builder.mutation<object, Partial<{ data: object }>>({
      query: ({ data }) => ({
        url: `workspace/${getWorkspace()}/workforce/manager`,
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["manager"],
    }),

    //toggle status of manager
    toggleManagerStatus: builder.mutation<
      unknown,
      { userId: string; status: string }
    >({
      query: ({ userId, status }) => ({
        url: `/workspace/${getWorkspace()}/workforce/manager/${userId}/${status}`,
        method: "POST",
      }),
      invalidatesTags: ["manager"],
    }),
  }),
});

export const {
  useAddManagerByWsMutation,
  useAlterManagerByWsMutation,
  useGetManagerByWSQuery,
  useGetManagerListQuery,
  useGetSingleManagerByWsQuery,
  useToggleManagerStatusMutation,
} = managerApi;
